import { Icon } from "../Icon";
import styled from "styled-components";

type Props = { prevImage: () => void; nextImage: () => void };

export const Arrows = ({ prevImage, nextImage }: Props) => {
  return (
    <Container>
      <Arrow className="prev" name="previous arrow" onClick={prevImage}>
        <Icon iconName="chevron-left" iconSize="medium" plain type="white" />
      </Arrow>
      <Arrow className="next" name="next arrow" onClick={nextImage}>
        <Icon iconName="chevron-right" iconSize="medium" plain type="white" />
      </Arrow>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
`;

const Arrow = styled.button`
  cursor: pointer;
  border: none;
  flex-grow: 1;
  display: flex;
  align-items: center;
  outline: none;
  &.prev {
    justify-content: flex-start;
    background: linear-gradient(
      90deg,
      rgba(50, 62, 72, 0.48) 0%,
      rgba(50, 62, 72, 0) 100%
    );
  }
  &.next {
    justify-content: flex-end;
    background: linear-gradient(
      90deg,
      rgba(50, 62, 72, 0) 0%,
      rgba(50, 62, 72, 0.48) 100%
    );
  }
`;
